module.exports = __webpack_public_path__ + "img/hive.d320c1dd.jpg";